import _ from 'lodash'
import { StyleSheet, Text, View, Modal, Button, Platform, TouchableOpacity, Image, SafeAreaView, ScrollView, useWindowDimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import Ionicons from '@expo/vector-icons/Ionicons';
import { colors } from '../../colors'
import Header from '../../components/Header'
import Cards from '../../components/Cards'
import {movies} from '../../data'
import useSelectedRoutes from '../../hooks/useSelectedRoutes'
import Downloads from '../../components/Downloads'
import VideoBackground from '../../components/VideoBackground'
import { Video } from 'expo-av'
import Footer from '../../components/Footer'
import AboutUS from '../../components/AboutUS';

const HomeScreen = () => {
  const {selectedRoute, setSelectedRoute} = useSelectedRoutes();
  const [ videoUrl, setVideoUrl ] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [featuredIndex, setFeaturedIndex] = useState(0);
  const window = useWindowDimensions();
  const narrow = window.width < 768;
  const featuredFilm = movies[featuredIndex] || movies[0];

  useEffect(() => {
    if (!narrow || isVisible) return undefined;
    setVideoUrl(featuredFilm?.videoUrl || '');
    const timer = setInterval(() => {
      setFeaturedIndex((current) => (current + 1) % movies.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [narrow, isVisible, featuredIndex]);

  return (
      <View style={[styles.container, narrow && { backgroundColor: 'transparent', overflow: 'visible' }]}>
        <VideoBackground cover={narrow} videoUrl={narrow ? (videoUrl || movies[0]?.videoUrl) : videoUrl} />
        {!(narrow && selectedRoute === 'HOME') && <View style={styles.backdrop}></View>}
        <Header selectedRoute={selectedRoute} setSelectedRoute={setSelectedRoute} />
        <View style={[styles.body, narrow && styles.bodyNarrow]}>
          <Modal
            animationType={'slide'}
            onRequestClose={() => setIsVisible(false)}
            visible={isVisible}
          >
            <View style={styles.container}>
              <VideoBackground muted={false} controls={true} videoUrl={videoUrl} />
              <TouchableOpacity onPress={() => setIsVisible(false)} style={styles.backButton}>
                <Ionicons name="arrow-back-circle-outline" size={70} color={colors.white} />
              </TouchableOpacity>
              <Image resizeMode='contain' style={styles.titleCard} source={{uri: `https://ivyooo.com/assets/images/${videoUrl}.png`}} />
            </View>
          </Modal>
          {selectedRoute === 'HOME' && (
            narrow ? (
              <ScrollView style={styles.moviesScroll} contentContainerStyle={styles.moviesNarrow}>
                <Cards featured setIsVisible={setIsVisible} setVideoUrl={setVideoUrl} isTop={false} index={featuredIndex} genre={featuredFilm?.genre} posterUrl={featuredFilm?.posterUrl} name={featuredFilm?.name} titleCardUrl={featuredFilm?.titleCardUrl} url={featuredFilm?.videoUrl} />
                <ScrollView horizontal showsHorizontalScrollIndicator={false} snapToInterval={144} decelerationRate="fast" contentContainerStyle={styles.rail}>
                  {_.map(movies.slice(1), (item, index)=> <Cards rail key={`${item?.name}-${index}`} setIsVisible={setIsVisible} setVideoUrl={setVideoUrl} isTop={false} index={index + 1} genre={item?.genre} posterUrl={item?.posterUrl} name={item?.name} titleCardUrl={item?.titleCardUrl} url={item?.videoUrl} />)}
                </ScrollView>
                <Footer />
              </ScrollView>
            ) : (
              <View style={styles.movies} onMouseLeave={() => setHoveredIndex(null)}>
                {_.map(movies, (item, index)=> <Cards key={`${item?.name}-${index}`} hoveredIndex={hoveredIndex} onHoverIndex={setHoveredIndex} setIsVisible={setIsVisible} setVideoUrl={setVideoUrl} isTop={index % 2 == 0} index={index} genre={item?.genre} posterUrl={item?.posterUrl} name={item?.name} titleCardUrl={item?.titleCardUrl} url={item?.videoUrl} />)}
              </View>
            )
          )}
          {selectedRoute === 'DOWNLOADS' && <Downloads />}
          {selectedRoute === 'ABOUT US' && <AboutUS />}
        </View>
        {!(narrow && selectedRoute === 'HOME') && <Footer />}
      </View>
  )
}

export default HomeScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors.background,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    backButton: {
      width: 50,
      height: 50,
      position: 'absolute',
      top: 40,
      justifyContent: 'center',
      alignItems: 'center',
      left: 40,
    },
    backdrop: {
      flex: 1,
      backgroundColor: colors.background,
      opacity: 0.8,
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    backdropNarrow: {
      opacity: 0.28,
    },
    body: {
      flex: 1,
      flexDirection: 'row',
    },
    bodyNarrow: {
      flexDirection: 'column',
    },
    sidebar: {
      width: 300,
      position: 'absolute',
      alignSelf: 'center',
      left: 0,
      height: '40%',
    },
    sidebarNarrow: {
      width: '100%',
      height: 'auto',
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignSelf: 'stretch',
      left: 0,
      paddingTop: 8,
    },
    movies: {
      flex: 8,
      paddingVertical: 0,
      paddingHorizontal: 0,
      marginLeft: 0,
      justifyContent: 'center',
      alignItems: 'stretch',
      flexDirection: 'row',
      overflow: 'visible',
    },
    moviesScroll: {
      flex: 1,
      width: '100%',
    },
    moviesNarrow: {
      paddingTop: 0,
      paddingBottom: 24,
    },
    rail: {
      paddingHorizontal: 16,
      paddingTop: 8,
      paddingBottom: 8,
    },
    titleCard: {
      position: 'absolute',
      width: '20%',
      height: 80,
      margin: 20,
      alignSelf: 'center',
    }
})